import { auth, firebase } from "src/firebase";

export async function signIn({ email, password }) {
  await auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
  try {
    const signIn: any = await auth.signInWithEmailAndPassword(email, password);
    console.log("signIn?.code", signIn);
    if (signIn?.code) throw signIn?.code;
  } catch (e) {
    throw e;
    console.error("signIn?.code", e);
  }
}
